var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { SlotDto } from './slot.dto.js';
import { SlotSearchWarningDto } from './slot-search-warning.dto.js';
import { WeeklyFrequencyViolationDto } from './weekly-frequency-violation.dto.js';
export class FindEarliestSlotsResponseDto {
    slots;
    weeklyFrequencyViolations;
    /**
     * Non-gating advisories about the assembled schedule (PRD #928 / RS-007).
     * Always present; empty when nothing to flag. `PREFER_EARLIEST` never emits
     * warnings (byte-for-byte unchanged shape: `warnings = []`).
     */
    warnings;
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => SlotDto),
    __metadata("design:type", Array)
], FindEarliestSlotsResponseDto.prototype, "slots", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => WeeklyFrequencyViolationDto),
    __metadata("design:type", Array)
], FindEarliestSlotsResponseDto.prototype, "weeklyFrequencyViolations", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => SlotSearchWarningDto),
    __metadata("design:type", Array)
], FindEarliestSlotsResponseDto.prototype, "warnings", void 0);
//# sourceMappingURL=find-earliest-slots-response.dto.js.map